"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[343],{

/***/ 16343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ third_party; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/service/auth.js
var auth = __webpack_require__(96908);
// EXTERNAL MODULE: ./src/constants/env.ts
var env = __webpack_require__(70340);
// EXTERNAL MODULE: ./node_modules/firebase/app/dist/esm/index.esm.js
var index_esm = __webpack_require__(83977);
// EXTERNAL MODULE: ./node_modules/firebase/analytics/dist/esm/index.esm.js + 1 modules
var esm_index_esm = __webpack_require__(99261);
;// CONCATENATED MODULE: ./src/constants/firebase.ts
// worker 번들러랑 코드 공유하는데 worker 번들러에 @ resovler가 사용설정되어 있지 않아서 import 경로에 '@' 사용 못함에 유의

var firebaseConfig = env/* IS_PRODUCTION_OPERATION */.Sy ? {
    apiKey: "AIzaSyA47-Q_Q_qFtCveD-xdfDJnn_Y8uW2Eln0",
    authDomain: "therich-io-dev.firebaseapp.com",
    databaseURL: "https://therich-io-dev.firebaseio.com",
    projectId: "therich-io-dev",
    storageBucket: "therich-io-dev.appspot.com",
    messagingSenderId: "1517924880",
    appId: "1:1517924880:web:98ff79c9cc2cafe1619095",
    measurementId: "G-S2JPD7PL80"
} : {
    apiKey: "AIzaSyAUEDXVquxkj1Ybe6F3pQh-flDk1hH9pkw",
    authDomain: "therich-chat.firebaseapp.com",
    databaseURL: "https://therich-chat.firebaseio.com",
    projectId: "therich-chat",
    storageBucket: "therich-chat.appspot.com",
    messagingSenderId: "826593673837",
    appId: "1:826593673837:web:97b83b704eed8fc4983564"
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/firebase/firestore/dist/esm/index.esm.js
var dist_esm_index_esm = __webpack_require__(39828);
// EXTERNAL MODULE: ./node_modules/firebase/auth/dist/esm/index.esm.js + 1 modules
var auth_dist_esm_index_esm = __webpack_require__(91259);
// EXTERNAL MODULE: ./src/utils/jwt/is-expired.ts
var is_expired = __webpack_require__(41790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(31230);
;// CONCATENATED MODULE: ./src/gql/generated-chat.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SignInChat($authToken: String!, $deviceToken: String) {\n  signInChat(authToken: $authToken, deviceToken: $deviceToken) {\n    uid\n    token\n  }\n}\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation CreateChatRoom($chatIdToken: String!, $roomName: String!, $roomType: String!, $language: String!) {\n  createChatRoom(\n    chatIdToken: $chatIdToken\n    roomName: $roomName\n    roomType: $roomType\n    language: $language\n  ) {\n    id\n    roomName\n    roomType\n    language\n    linkUrl\n  }\n}\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation EnterChatRoom($chatIdToken: String!, $chatId: String!, $password: String) {\n  enterChatRoom(chatIdToken: $chatIdToken, chatId: $chatId, password: $password) {\n    id\n  }\n}\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation EnterStockChatRoom($chatIdToken: String!, $exchange: String!, $ticker: String!, $language: String!) {\n  enterStockChatRoom(\n    chatIdToken: $chatIdToken\n    exchange: $exchange\n    ticker: $ticker\n    language: $language\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation EnterCryptoCurrencyChatRoom($chatIdToken: String!, $cryptoCurrencyId: ID!, $language: String!) {\n  enterCryptoCurrencyChatRoom(\n    chatIdToken: $chatIdToken\n    cryptoCurrencyId: $cryptoCurrencyId\n    language: $language\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation LeaveChatRoom($chatIdToken: String!, $chatId: String!) {\n  leaveChatRoom(chatIdToken: $chatIdToken, chatId: $chatId) {\n    id\n  }\n}\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation SendMessageToChatRoom($chatIdToken: String!, $chatId: String!, $owner: OwnerInput!, $content: [ContentInput]!) {\n  sendMessageToChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    message: {owner: $owner, content: $content}\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UploadChatFile($file: Upload!, $chatId: String!, $chatIdToken: String!, $width: Int, $height: Int) {\n  uploadChatFile(\n    file: $file\n    chatId: $chatId\n    chatIdToken: $chatIdToken\n    width: $width\n    height: $height\n  ) {\n    filename\n    imageUrl\n  }\n}\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateRoomImage($file: Upload!, $chatId: String!, $chatIdToken: String!, $width: Int, $height: Int) {\n  updateRoomImage(\n    file: $file\n    chatId: $chatId\n    chatIdToken: $chatIdToken\n    width: $width\n    height: $height\n  ) {\n    filename\n    roomImageUrl\n    adminId\n    managerIds\n    roomName\n    roomType\n    users {\n      id\n      nickname\n      profileImage\n    }\n  }\n}\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation BanUserAtChatRoom($chatIdToken: String!, $chatId: String!, $banUserId: ID!) {\n  banUserAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    banUserId: $banUserId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveBannedUserAtChatRoom($chatIdToken: String!, $chatId: String!, $banUserId: ID!) {\n  removeBannedUserAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    banUserId: $banUserId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddManagerToChatRoom($chatIdToken: String!, $chatId: String!, $userId: ID!) {\n  addManagerToChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    userId: $userId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation RemoveManagerToChatRoom($chatIdToken: String!, $chatId: String!, $userId: ID!) {\n  removeManagerToChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    userId: $userId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation TurnOnNotificationStatus($chatIdToken: String!, $chatId: String!, $deviceToken: String!) {\n  turnOnNotificationStatus(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    deviceToken: $deviceToken\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation TurnOffNotificationStatus($chatIdToken: String!, $chatId: String!, $deviceToken: String!) {\n  turnOffNotificationStatus(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    deviceToken: $deviceToken\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdatePasswordAtChatRoom($chatIdToken: String!, $chatId: String!, $password: String!) {\n  updatePasswordAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    password: $password\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateRoomNameAtChatRoom($chatIdToken: String!, $chatId: String!, $roomName: String!) {\n  updateRoomNameAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    roomName: $roomName\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation AddNoticeMessageAtChatRoom($chatIdToken: String!, $chatId: String!, $messageId: String!) {\n  addNoticeMessageAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    messageId: $messageId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation HideMessageAtChatRoom($chatIdToken: String!, $chatId: String!, $messageId: ID!) {\n  hideMessageAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    messageId: $messageId\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation ToggleReactionToMessageAtChatRoom($chatIdToken: String!, $chatId: ID!, $messageId: ID!, $reactionType: ReactionTypeEnum!) {\n  toggleReactionToMessageAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    messageId: $messageId\n    reactionType: $reactionType\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation ReplyToMessageAtChatRoom($chatIdToken: String!, $chatId: ID!, $replyToMessageId: ID!, $owner: OwnerInput!, $content: [ContentInput]!) {\n  replyToMessageAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    replyToMessageId: $replyToMessageId\n    message: {owner: $owner, content: $content}\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateNicknameAtChatRoom($chatIdToken: String!, $chatId: String!, $nickname: String!) {\n  updateNicknameAtChatRoom(\n    chatIdToken: $chatIdToken\n    chatId: $chatId\n    nickname: $nickname\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UpdateProfileImage($file: Upload!, $chatId: String!, $chatIdToken: String!, $width: Int, $height: Int) {\n  updateProfileImage(\n    file: $file\n    chatId: $chatId\n    chatIdToken: $chatIdToken\n    width: $width\n    height: $height\n  ) {\n    id\n  }\n}\n    "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}


var defaultOptions = {};
var CacheControlScope;
(function(CacheControlScope) {
    CacheControlScope["Private"] = "PRIVATE";
    CacheControlScope["Public"] = "PUBLIC";
})(CacheControlScope || (CacheControlScope = {}));
var ReactionTypeEnum;
(function(ReactionTypeEnum) {
    ReactionTypeEnum["Heart"] = "HEART";
    ReactionTypeEnum["Like"] = "LIKE";
    ReactionTypeEnum["Money"] = "MONEY";
    ReactionTypeEnum["Smile"] = "SMILE";
    ReactionTypeEnum["Surprise"] = "SURPRISE";
    ReactionTypeEnum["Tears"] = "TEARS";
})(ReactionTypeEnum || (ReactionTypeEnum = {}));
var generated_chat_SignInChatDocument = (0,lib/* gql */.Ps)(_templateObject());
/**
 * __useSignInChatMutation__
 *
 * To run a mutation, you first call `useSignInChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInChatMutation, { data, loading, error }] = useSignInChatMutation({
 *   variables: {
 *      authToken: // value for 'authToken'
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */ function useSignInChatMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(generated_chat_SignInChatDocument, options);
}
var CreateChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject1());
/**
 * __useCreateChatRoomMutation__
 *
 * To run a mutation, you first call `useCreateChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatRoomMutation, { data, loading, error }] = useCreateChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      roomName: // value for 'roomName'
 *      roomType: // value for 'roomType'
 *      language: // value for 'language'
 *   },
 * });
 */ function useCreateChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(CreateChatRoomDocument, options);
}
var EnterChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject2());
/**
 * __useEnterChatRoomMutation__
 *
 * To run a mutation, you first call `useEnterChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterChatRoomMutation, { data, loading, error }] = useEnterChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      password: // value for 'password'
 *   },
 * });
 */ function useEnterChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(EnterChatRoomDocument, options);
}
var EnterStockChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject3());
/**
 * __useEnterStockChatRoomMutation__
 *
 * To run a mutation, you first call `useEnterStockChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterStockChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterStockChatRoomMutation, { data, loading, error }] = useEnterStockChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      exchange: // value for 'exchange'
 *      ticker: // value for 'ticker'
 *      language: // value for 'language'
 *   },
 * });
 */ function useEnterStockChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(EnterStockChatRoomDocument, options);
}
var EnterCryptoCurrencyChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject4());
/**
 * __useEnterCryptoCurrencyChatRoomMutation__
 *
 * To run a mutation, you first call `useEnterCryptoCurrencyChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnterCryptoCurrencyChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enterCryptoCurrencyChatRoomMutation, { data, loading, error }] = useEnterCryptoCurrencyChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      cryptoCurrencyId: // value for 'cryptoCurrencyId'
 *      language: // value for 'language'
 *   },
 * });
 */ function useEnterCryptoCurrencyChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(EnterCryptoCurrencyChatRoomDocument, options);
}
var LeaveChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject5());
/**
 * __useLeaveChatRoomMutation__
 *
 * To run a mutation, you first call `useLeaveChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveChatRoomMutation, { data, loading, error }] = useLeaveChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */ function useLeaveChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(LeaveChatRoomDocument, options);
}
var SendMessageToChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject6());
/**
 * __useSendMessageToChatRoomMutation__
 *
 * To run a mutation, you first call `useSendMessageToChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageToChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageToChatRoomMutation, { data, loading, error }] = useSendMessageToChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      owner: // value for 'owner'
 *      content: // value for 'content'
 *   },
 * });
 */ function useSendMessageToChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(SendMessageToChatRoomDocument, options);
}
var UploadChatFileDocument = (0,lib/* gql */.Ps)(_templateObject7());
/**
 * __useUploadChatFileMutation__
 *
 * To run a mutation, you first call `useUploadChatFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadChatFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadChatFileMutation, { data, loading, error }] = useUploadChatFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *      chatId: // value for 'chatId'
 *      chatIdToken: // value for 'chatIdToken'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *   },
 * });
 */ function useUploadChatFileMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UploadChatFileDocument, options);
}
var UpdateRoomImageDocument = (0,lib/* gql */.Ps)(_templateObject8());
/**
 * __useUpdateRoomImageMutation__
 *
 * To run a mutation, you first call `useUpdateRoomImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomImageMutation, { data, loading, error }] = useUpdateRoomImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      chatId: // value for 'chatId'
 *      chatIdToken: // value for 'chatIdToken'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *   },
 * });
 */ function useUpdateRoomImageMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdateRoomImageDocument, options);
}
var BanUserAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject9());
/**
 * __useBanUserAtChatRoomMutation__
 *
 * To run a mutation, you first call `useBanUserAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserAtChatRoomMutation, { data, loading, error }] = useBanUserAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      banUserId: // value for 'banUserId'
 *   },
 * });
 */ function useBanUserAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(BanUserAtChatRoomDocument, options);
}
var RemoveBannedUserAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject10());
/**
 * __useRemoveBannedUserAtChatRoomMutation__
 *
 * To run a mutation, you first call `useRemoveBannedUserAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBannedUserAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBannedUserAtChatRoomMutation, { data, loading, error }] = useRemoveBannedUserAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      banUserId: // value for 'banUserId'
 *   },
 * });
 */ function useRemoveBannedUserAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(RemoveBannedUserAtChatRoomDocument, options);
}
var AddManagerToChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject11());
/**
 * __useAddManagerToChatRoomMutation__
 *
 * To run a mutation, you first call `useAddManagerToChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManagerToChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManagerToChatRoomMutation, { data, loading, error }] = useAddManagerToChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useAddManagerToChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(AddManagerToChatRoomDocument, options);
}
var RemoveManagerToChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject12());
/**
 * __useRemoveManagerToChatRoomMutation__
 *
 * To run a mutation, you first call `useRemoveManagerToChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveManagerToChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeManagerToChatRoomMutation, { data, loading, error }] = useRemoveManagerToChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      userId: // value for 'userId'
 *   },
 * });
 */ function useRemoveManagerToChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(RemoveManagerToChatRoomDocument, options);
}
var TurnOnNotificationStatusDocument = (0,lib/* gql */.Ps)(_templateObject13());
/**
 * __useTurnOnNotificationStatusMutation__
 *
 * To run a mutation, you first call `useTurnOnNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOnNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOnNotificationStatusMutation, { data, loading, error }] = useTurnOnNotificationStatusMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */ function useTurnOnNotificationStatusMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(TurnOnNotificationStatusDocument, options);
}
var TurnOffNotificationStatusDocument = (0,lib/* gql */.Ps)(_templateObject14());
/**
 * __useTurnOffNotificationStatusMutation__
 *
 * To run a mutation, you first call `useTurnOffNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTurnOffNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [turnOffNotificationStatusMutation, { data, loading, error }] = useTurnOffNotificationStatusMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */ function useTurnOffNotificationStatusMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(TurnOffNotificationStatusDocument, options);
}
var UpdatePasswordAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject15());
/**
 * __useUpdatePasswordAtChatRoomMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordAtChatRoomMutation, { data, loading, error }] = useUpdatePasswordAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      password: // value for 'password'
 *   },
 * });
 */ function useUpdatePasswordAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdatePasswordAtChatRoomDocument, options);
}
var UpdateRoomNameAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject16());
/**
 * __useUpdateRoomNameAtChatRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomNameAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomNameAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomNameAtChatRoomMutation, { data, loading, error }] = useUpdateRoomNameAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      roomName: // value for 'roomName'
 *   },
 * });
 */ function useUpdateRoomNameAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdateRoomNameAtChatRoomDocument, options);
}
var AddNoticeMessageAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject17());
/**
 * __useAddNoticeMessageAtChatRoomMutation__
 *
 * To run a mutation, you first call `useAddNoticeMessageAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoticeMessageAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoticeMessageAtChatRoomMutation, { data, loading, error }] = useAddNoticeMessageAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */ function useAddNoticeMessageAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(AddNoticeMessageAtChatRoomDocument, options);
}
var HideMessageAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject18());
/**
 * __useHideMessageAtChatRoomMutation__
 *
 * To run a mutation, you first call `useHideMessageAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideMessageAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideMessageAtChatRoomMutation, { data, loading, error }] = useHideMessageAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */ function useHideMessageAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(HideMessageAtChatRoomDocument, options);
}
var ToggleReactionToMessageAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject19());
/**
 * __useToggleReactionToMessageAtChatRoomMutation__
 *
 * To run a mutation, you first call `useToggleReactionToMessageAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleReactionToMessageAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleReactionToMessageAtChatRoomMutation, { data, loading, error }] = useToggleReactionToMessageAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      messageId: // value for 'messageId'
 *      reactionType: // value for 'reactionType'
 *   },
 * });
 */ function useToggleReactionToMessageAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(ToggleReactionToMessageAtChatRoomDocument, options);
}
var ReplyToMessageAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject20());
/**
 * __useReplyToMessageAtChatRoomMutation__
 *
 * To run a mutation, you first call `useReplyToMessageAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyToMessageAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyToMessageAtChatRoomMutation, { data, loading, error }] = useReplyToMessageAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      replyToMessageId: // value for 'replyToMessageId'
 *      owner: // value for 'owner'
 *      content: // value for 'content'
 *   },
 * });
 */ function useReplyToMessageAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(ReplyToMessageAtChatRoomDocument, options);
}
var UpdateNicknameAtChatRoomDocument = (0,lib/* gql */.Ps)(_templateObject21());
/**
 * __useUpdateNicknameAtChatRoomMutation__
 *
 * To run a mutation, you first call `useUpdateNicknameAtChatRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNicknameAtChatRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNicknameAtChatRoomMutation, { data, loading, error }] = useUpdateNicknameAtChatRoomMutation({
 *   variables: {
 *      chatIdToken: // value for 'chatIdToken'
 *      chatId: // value for 'chatId'
 *      nickname: // value for 'nickname'
 *   },
 * });
 */ function useUpdateNicknameAtChatRoomMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdateNicknameAtChatRoomDocument, options);
}
var UpdateProfileImageDocument = (0,lib/* gql */.Ps)(_templateObject22());
/**
 * __useUpdateProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileImageMutation, { data, loading, error }] = useUpdateProfileImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *      chatId: // value for 'chatId'
 *      chatIdToken: // value for 'chatIdToken'
 *      width: // value for 'width'
 *      height: // value for 'height'
 *   },
 * });
 */ function useUpdateProfileImageMutation(baseOptions) {
    var options = _object_spread({}, defaultOptions, baseOptions);
    return Apollo.useMutation(UpdateProfileImageDocument, options);
}
var namedOperations = {
    Mutation: {
        SignInChat: "SignInChat",
        CreateChatRoom: "CreateChatRoom",
        EnterChatRoom: "EnterChatRoom",
        EnterStockChatRoom: "EnterStockChatRoom",
        EnterCryptoCurrencyChatRoom: "EnterCryptoCurrencyChatRoom",
        LeaveChatRoom: "LeaveChatRoom",
        SendMessageToChatRoom: "SendMessageToChatRoom",
        UploadChatFile: "UploadChatFile",
        UpdateRoomImage: "UpdateRoomImage",
        BanUserAtChatRoom: "BanUserAtChatRoom",
        RemoveBannedUserAtChatRoom: "RemoveBannedUserAtChatRoom",
        AddManagerToChatRoom: "AddManagerToChatRoom",
        RemoveManagerToChatRoom: "RemoveManagerToChatRoom",
        TurnOnNotificationStatus: "TurnOnNotificationStatus",
        TurnOffNotificationStatus: "TurnOffNotificationStatus",
        UpdatePasswordAtChatRoom: "UpdatePasswordAtChatRoom",
        UpdateRoomNameAtChatRoom: "UpdateRoomNameAtChatRoom",
        AddNoticeMessageAtChatRoom: "AddNoticeMessageAtChatRoom",
        HideMessageAtChatRoom: "HideMessageAtChatRoom",
        ToggleReactionToMessageAtChatRoom: "ToggleReactionToMessageAtChatRoom",
        ReplyToMessageAtChatRoom: "ReplyToMessageAtChatRoom",
        UpdateNicknameAtChatRoom: "UpdateNicknameAtChatRoom",
        UpdateProfileImage: "UpdateProfileImage"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/firebase/messaging/dist/esm/index.esm.js + 3 modules
var messaging_dist_esm_index_esm = __webpack_require__(5455);
;// CONCATENATED MODULE: ./src/api/firebase/firebase-message-token.ts



var messageToken = "";
/**
 * 브라우저 접속때마다 토큰을 발급하므로 별도로 local에 저장하지 않음
 */ function firebase_message_token_firebaseMessageToken() {
    return _firebaseMessageToken.apply(this, arguments);
};
function _firebaseMessageToken() {
    _firebaseMessageToken = (0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var isSupport, messaging, serviceWorkerRegistration;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!messageToken) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        messageToken: messageToken,
                        messaging: null
                    });
                case 2:
                    _ctx.next = 4;
                    return (0,messaging_dist_esm_index_esm/* isSupported */.Gb)() // safari는 아직 지원안함
                    ;
                case 4:
                    isSupport = _ctx.sent;
                    if (!(!isSupport || !navigator.serviceWorker)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        messageToken: messageToken,
                        messaging: null
                    });
                case 7:
                    messaging = (0,messaging_dist_esm_index_esm/* getMessaging */.KL)();
                    _ctx.next = 10;
                    return new Promise(function(resolve) {
                        var timeoutId = setTimeout(function() {
                            return resolve(null);
                        }, 2000);
                        navigator.serviceWorker.ready.then(function(sw) {
                            clearTimeout(timeoutId);
                            resolve(sw);
                        });
                    });
                case 10:
                    serviceWorkerRegistration = _ctx.sent;
                    if (serviceWorkerRegistration) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        messageToken: messageToken,
                        messaging: null
                    });
                case 13:
                    _ctx.next = 15;
                    return (0,messaging_dist_esm_index_esm/* getToken */.LP)(messaging, {
                        vapidKey: "BM2-leKeD8L8DV0aj0znHSLGTVdEPMQsCNUlu5mXHYDKfIjOBD7zS-FxszZGOytZWqltDfnYFGtEZ1WuCfcEkho",
                        serviceWorkerRegistration: serviceWorkerRegistration
                    }).then(function(currentToken) {
                        if (currentToken) return currentToken;
                        ;
                        return "";
                    }).catch(function(err) {
                        ;
                        return "";
                    });
                case 15:
                    messageToken = _ctx.sent;
                    return _ctx.abrupt("return", {
                        messageToken: messageToken,
                        messaging: messaging
                    });
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _firebaseMessageToken.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 7 modules
var ApolloClient = __webpack_require__(49538);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 6 modules
var inMemoryCache = __webpack_require__(13440);
// EXTERNAL MODULE: ./src/apollo-client/isomorphic-apollo-client.ts
var isomorphic_apollo_client = __webpack_require__(86464);
// EXTERNAL MODULE: ./src/apollo-client/http-link.ts + 2 modules
var http_link = __webpack_require__(33824);
;// CONCATENATED MODULE: ./src/apollo-client/chat-server-apollo-client.ts



function createChatServerApolloClient(param) {
    var isServer = param.isServer;
    var client = new ApolloClient/* ApolloClient */.f({
        ssrMode: isServer,
        link: (0,http_link/* default */.Z)({
            uri: "https://dev-chat.therich.dev/graphql"
        }),
        cache: new inMemoryCache/* InMemoryCache */.h()
    });
    return client;
}
var chat_server_apollo_client_chatServerApolloClient = (0,isomorphic_apollo_client/* default */.Z)(createChatServerApolloClient);
/* harmony default export */ var chat_server_apollo_client = ((/* unused pure expression or super */ null && (chat_server_apollo_client_chatServerApolloClient)));

// EXTERNAL MODULE: ./src/service/auth/store.ts
var store = __webpack_require__(46782);
// EXTERNAL MODULE: ./src/utils/toast/index.ts
var toast = __webpack_require__(1157);
;// CONCATENATED MODULE: ./src/service/chat/chat-token.ts









var oneMin = (/* unused pure expression or super */ null && (1000 * 60)) // 토큰 유효시간 1분 보정값
;
var chatToken = "";
function chat_token_getChatToken() {
    return _getChatToken.apply(this, arguments);
};
function _getChatToken() {
    _getChatToken = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var authToken, ref, messageToken, data, ref1, _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authToken = (_args.length > 0 && _args[0] !== void 0 ? _args[0] : {
                        authToken: authTokenStore().token
                    }).authToken;
                    _ctx.prev = 1;
                    if (!(authToken && (!chatToken || isExpired(chatToken, {
                        correction: oneMin
                    })))) {
                        _ctx.next = 12;
                        break;
                    }
                    ;
                    _ctx.next = 6;
                    return firebaseMessageToken();
                case 6:
                    messageToken = _ctx.sent.messageToken;
                    _ctx.next = 9;
                    return chatServerApolloClient().mutate({
                        mutation: SignInChatDocument,
                        variables: {
                            authToken: authToken,
                            deviceToken: messageToken
                        }
                    });
                case 9:
                    data = _ctx.sent.data;
                    ;
                    // chatToken: 발급후 1시간 유효
                    chatToken = (ref1 = data === null || data === void 0 ? void 0 : (ref = data.signInChat) === null || ref === void 0 ? void 0 : ref.token) !== null && ref1 !== void 0 ? ref1 : "";
                case 12:
                    return _ctx.abrupt("return", chatToken);
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    errorToast("failed to request SignInChat");
                    sendErrorLog(_ctx.t0);
                    return _ctx.abrupt("return", "");
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }));
    return _getChatToken.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/api/firebase/firebase-auth.ts







var firebase_auth_oneMin = (/* unused pure expression or super */ null && (1000 * 60)) // 토큰 유효시간 1분 보정값
;
var idToken = "";
/**
 * 채팅을 할 수 있도록 권한을 가진 firebase auth 토큰 생성
 * @param chatToken signInChat GQL 통해서 얻은 토큰
 */ function firebase_auth_signInWithCustomToken() {
    return _signInWithCustomToken1.apply(this, arguments);
}
function _signInWithCustomToken1() {
    _signInWithCustomToken1 = _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var ref, authToken, chatToken, auth;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!(!idToken || isExpired(idToken, {
                        correction: firebase_auth_oneMin
                    }))) {
                        _ctx.next = 20;
                        break;
                    }
                    ref = authTokenStore(), authToken = ref.token;
                    if (authToken) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", idToken);
                case 5:
                    _ctx.next = 7;
                    return getChatToken({
                        authToken: authToken
                    });
                case 7:
                    chatToken = _ctx.sent;
                    if (chatToken) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", idToken);
                case 10:
                    auth = getAuth();
                    _ctx.next = 13;
                    return _signInWithCustomToken(auth, chatToken);
                case 13:
                    if (!auth.currentUser) {
                        _ctx.next = 19;
                        break;
                    }
                    _ctx.next = 16;
                    return getIdToken(auth.currentUser);
                case 16:
                    // idToken: 발급후 1시간 유효
                    idToken = _ctx.sent;
                    _ctx.next = 20;
                    break;
                case 19:
                    throw new Error("not exist firebase auth.currentUser");
                case 20:
                    return _ctx.abrupt("return", idToken);
                case 23:
                    _ctx.prev = 23;
                    _ctx.t0 = _ctx["catch"](0);
                    sendErrorLog(_ctx.t0);
                    return _ctx.abrupt("return", "");
                case 27:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                23
            ]
        ]);
    }));
    return _signInWithCustomToken1.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/api/firebase/firestore.ts








var firestoreDB = null;
function getFirestoreDB() {
    if (firestoreDB === null) {
        firestoreDB = (0,dist_esm_index_esm/* getFirestore */.ad)();
    }
    return firestoreDB;
};
var COL = {
    CHAT_SYSTEM: "chat-system",
    USERS: "users",
    CHATS: "chats",
    CHAT_USERS: "chat-users",
    MESSAGES: "messages",
    CHAT_NOTIFICATIONS: "chat-notifications"
};
var DOC = (0,_define_property/* default */.Z)({}, COL.CHAT_SYSTEM, {
    PUBLIC_CHAT_USERS: "public-chat-users",
    PUBLIC_CHATS: "public-chats"
});
function responseHandler(param) {
    var onSuccess = param.onSuccess, onError = param.onError, exists = param.exists, getData = param.getData, errorMessage = param.errorMessage;
    if (exists) {
        onSuccess(getData());
    } else {
        sendErrorLog(new Error(errorMessage.en));
        onError(errorMessage);
    }
}
function subscribePublicChats(onSuccess, onError) {
    return onSnapshot(doc(getFirestoreDB(), COL.CHAT_SYSTEM, DOC[COL.CHAT_SYSTEM].PUBLIC_CHATS), function(doc) {
        responseHandler({
            onSuccess: onSuccess,
            onError: onError,
            exists: doc.exists(),
            getData: function() {
                return doc.get("publicChats");
            },
            errorMessage: {
                en: "publicChats not exists",
                ko: "존재하지 않는 공개 채팅방"
            }
        });
    }, sendErrorLog);
}
// chat id를 기반으로 하는 참여한 유저정보를 모두 가져옴(collection 기반이 아니라 쿼리 못함)
function subscribePublicChatsUsers(callback) {
    return onSnapshot(doc(getFirestoreDB(), COL.CHAT_SYSTEM, DOC[COL.CHAT_SYSTEM].PUBLIC_CHAT_USERS), function(doc) {
        if (doc.exists()) {
            callback(doc.get("publicChatUsers"));
        } else {
            sendErrorLog(new Error("publicChatUsers not exists"));
        }
    }, sendErrorLog);
}
// 비공개 채팅방(주주 모임방 포함)에 한해서 입장된 채팅방(공개는 subscribePublicChats 에서 구독)
function subscribeMyChats(callback, userId) {
    return onSnapshot(doc(getFirestoreDB(), COL.USERS, userId), function(doc) {
        if (doc.exists()) {
            callback(doc.get("myChats"));
        } else {
        // 실제로 없을 수 있음
        // sendErrorLog(new Error('myChatRooms not exists'))
        }
    }, sendErrorLog);
}
function subscribeChatMessage(callback, chatId, fetchLimit) {
    try {
        var messageRef = collection(getFirestoreDB(), COL.CHATS, chatId, COL.MESSAGES);
        return onSnapshot(query(messageRef, orderBy("createdAt", "desc"), limit(fetchLimit)), function(querySnapshot) {
            var messages = [];
            querySnapshot.docChanges().forEach(function(change) {
                switch(change.type){
                    case "added":
                    case "modified":
                        if (change.doc.exists()) {
                            var message = change.doc.data();
                            message["id"] = change.doc.id;
                            message["changeType"] = change.type;
                            messages.push(message);
                        }
                        break;
                }
            });
            callback(messages);
        });
    } catch (error) {
        sendErrorLog(error);
        var fallbackFunc = function() {
            return null;
        };
        return fallbackFunc;
    }
}
function subscribeChat(onSuccess, onError, chatId) {
    try {
        var chatRef = doc(getFirestoreDB(), COL.CHATS, chatId);
        return onSnapshot(chatRef, function(doc) {
            responseHandler({
                onSuccess: onSuccess,
                onError: onError,
                exists: doc.exists(),
                getData: function() {
                    var chat = doc.data();
                    if (chat.roomType === "stock" || chat.roomType === "crypto") {
                        // 자산방은 chat id 필드가 없음..
                        return _object_spread_props(_object_spread({}, chat), {
                            id: chatId
                        });
                    }
                    return chat;
                },
                errorMessage: {
                    en: "chatRoom not exists: chatId(".concat(chatId, ") "),
                    ko: "존재하지 않는 공개 채팅방: chatId(".concat(chatId, ")")
                }
            });
        });
    } catch (error) {
        sendErrorLog(error);
        var fallbackFunc = function() {
            return null;
        };
        return fallbackFunc;
    }
}
function subscribeChatUsers(callback, chatId) {
    try {
        var chatUsersRef = doc(getFirestoreDB(), COL.CHAT_USERS, chatId);
        return onSnapshot(chatUsersRef, function(doc) {
            if (doc.exists()) {
                callback(doc.data());
            } else {
                sendErrorLog(new Error("chatId(".concat(chatId, ") chatUser not exists")));
            }
        }, sendErrorLog);
    } catch (error) {
        sendErrorLog(error);
        var fallbackFunc = function() {
            return null;
        };
        return fallbackFunc;
    }
}
function subscribeChatNotification(callback, chatId) {
    var chatNotificationRef = doc(getFirestoreDB(), COL["CHAT_NOTIFICATIONS"], chatId);
    return onSnapshot(chatNotificationRef, function(doc) {
        if (doc.exists()) {
            callback(doc.data());
        }
    }, sendErrorLog);
}
function queryPrevChatMessages(_) {
    return _queryPrevChatMessages.apply(this, arguments);
}
function _queryPrevChatMessages() {
    _queryPrevChatMessages = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var chatId, messageCreatedAt, fetchLimit, chatUsersRef, q, querySnapshot, messages;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chatId = param.chatId, messageCreatedAt = param.messageCreatedAt, fetchLimit = param.fetchLimit;
                    chatUsersRef = collection(getFirestoreDB(), COL.CHATS, chatId, COL.MESSAGES);
                    q = query(chatUsersRef, where("createdAt", "<", messageCreatedAt), orderBy("createdAt", "desc"), limit(fetchLimit));
                    _ctx.next = 5;
                    return getDocs(q);
                case 5:
                    querySnapshot = _ctx.sent;
                    messages = [];
                    if (!querySnapshot.empty) {
                        querySnapshot.forEach(function(doc) {
                            var message = doc.data();
                            message["id"] = doc.id;
                            messages.push(message);
                        });
                    }
                    return _ctx.abrupt("return", messages);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _queryPrevChatMessages.apply(this, arguments);
}
function queryChat(_) {
    return _queryChat.apply(this, arguments);
}
function _queryChat() {
    _queryChat = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var chatId, chatRef, chatSnapshot, chat;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chatId = param.chatId;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return signInWithCustomToken() // firestore rule에 의존하는 로직
                    ;
                case 4:
                    chatRef = doc(getFirestore(), COL.CHATS, chatId);
                    _ctx.next = 7;
                    return getDoc(chatRef);
                case 7:
                    chatSnapshot = _ctx.sent;
                    if (!chatSnapshot.exists()) {
                        _ctx.next = 13;
                        break;
                    }
                    chat = chatSnapshot.data();
                    if (!(chat.roomType === "stock")) {
                        _ctx.next = 12;
                        break;
                    }
                    return _ctx.abrupt("return", _object_spread_props(_object_spread({}, chat), {
                        id: chatId
                    }));
                case 12:
                    return _ctx.abrupt("return", chat);
                case 13:
                    _ctx.next = 19;
                    break;
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    sendErrorLog(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 19:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }));
    return _queryChat.apply(this, arguments);
}
// 공개방인 경우는 사용 못함
function queryMyChat(_) {
    return _queryMyChat.apply(this, arguments);
}
function _queryMyChat() {
    _queryMyChat = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var chatId, userId, myChatRef, q, querySnapshot, chatRoom;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chatId = param.chatId, userId = param.userId;
                    myChatRef = collection(getFirestoreDB(), COL.USERS, userId, COL.CHATS);
                    q = query(myChatRef, where("id", "==", chatId), limit(1));
                    _ctx.next = 5;
                    return getDocs(q);
                case 5:
                    querySnapshot = _ctx.sent;
                    chatRoom = [];
                    if (querySnapshot.empty) {
                        _ctx.next = 10;
                        break;
                    }
                    querySnapshot.forEach(function(doc) {
                        chatRoom.push(doc.data());
                    });
                    return _ctx.abrupt("return", chatRoom[0]);
                case 10:
                    return _ctx.abrupt("return", null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _queryMyChat.apply(this, arguments);
}
function queryChatUsers(_) {
    return _queryChatUsers.apply(this, arguments);
}
function _queryChatUsers() {
    _queryChatUsers = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var chatId, chatUsersRef, chatUsersSnapshot;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chatId = param.chatId;
                    _ctx.prev = 1;
                    chatUsersRef = doc(getFirestoreDB(), COL.CHAT_USERS, chatId);
                    _ctx.next = 5;
                    return getDoc(chatUsersRef);
                case 5:
                    chatUsersSnapshot = _ctx.sent;
                    if (!chatUsersSnapshot.exists()) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", chatUsersSnapshot.data());
                case 8:
                    return _ctx.abrupt("return", null);
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    sendErrorLog(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return _queryChatUsers.apply(this, arguments);
}
function queryChatNotifications(_) {
    return _queryChatNotifications.apply(this, arguments);
} /**
 * 파이어스토어를 이용한 채팅 서비스
 *
 * 기본적으로 채팅 정보는 파이어스토어와 GQL 혼합해서 사용한다.
 * 파이어스토어 이용 로직
 * 1. 퍼블릭 채팅방 관련
 * 2. 특정유저(로그인 유저) 채팅방 관련(public/private 모두)
 * 3. 특정 주식 채팅방 관련
 * 4. 채팅방 메시지
 *
 * 채팅방 타입은 3가지
 * 1. public(공개)
 *   - roomType === 'public'
 * 2. private(비공개)
 *   - roomType === 'private'
 * 3. stock(주주 모임)
 *   - roomType === 'stock'
 * 3. crypto(주주 모임)
 *   - roomType === 'crypto'
 *
 * UI 노출 채팅방 타입 3가지
 * 1. 참여한 채팅방
 *   - 참여한 공개 및 비공개 채팅방
 * 2. 추천 채팅방
 *   - 공개 중 참여한지 않은 채팅방
 * 3. 주주 모임
 *   - 참여한 채팅방은 보여주고 특정 주식 검색 후 참여할 수 있도록 제공
 *
 * 채팅에 필요한 토큰 로직
 * 채팅서버로 authToken 사용하여 chatToken 획득
 * chatToken으로 firebase auth custom token 요청하여 idToken(chatIdToken) 획득
 * idToken 으로 채팅 권한관련 GQL 뮤테이션시 사용
 *
 */ 
function _queryChatNotifications() {
    _queryChatNotifications = _async_to_generator(regeneratorRuntime.mark(function _callee(param) {
        var chatId, chatNotificationRef, chatNotificationSnapshot;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    chatId = param.chatId;
                    chatNotificationRef = doc(getFirestoreDB(), COL["CHAT_NOTIFICATIONS"], chatId);
                    _ctx.next = 4;
                    return getDoc(chatNotificationRef);
                case 4:
                    chatNotificationSnapshot = _ctx.sent;
                    if (!chatNotificationSnapshot.exists()) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", chatNotificationSnapshot.data());
                case 7:
                    return _ctx.abrupt("return", null);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _queryChatNotifications.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/api/firebase/initialize.ts





function initialize() {
    if (typeof __webpack_require__.g.window !== "undefined" && !(0,index_esm/* getApps */.C6)().length) {
        (0,index_esm/* initializeApp */.ZF)(firebaseConfig);
        env/* IS_PRODUCTION_OPERATION */.Sy && (0,esm_index_esm/* getAnalytics */.IH)();
        getFirestoreDB();
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/gql/generated-api1.ts + 2 modules
var generated_api1 = __webpack_require__(52177);
// EXTERNAL MODULE: ./src/utils/language/language-hook.ts
var language_hook = __webpack_require__(54576);
;// CONCATENATED MODULE: ./src/route/chats/index.ts
var CHATS_PATH = "/chats";
var chatPath = function() {
    var chatId = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).chatId;
    return chatId ? "".concat(CHATS_PATH, "/").concat(chatId) : CHATS_PATH;
};
var isChattingPage = function() {
    return(// [/?] : /chats?chatId=123123 or /chats/123123 path 확인
    typeof __webpack_require__.g.location !== "undefined" && /\/chats[/?].+/.test(location.href));
};

;// CONCATENATED MODULE: ./src/api/firebase/firebase-cloud-messaging-hook.ts











function useFirebaseCloudMessaging() {
    var clientTokenRef = react.useRef("");
    var token = (0,store/* useAuthTokenStore */.wX)().token;
    var language = (0,language_hook/* default */.Z)().language;
    var ref = (0,_sliced_to_array/* default */.Z)((0,generated_api1/* useUpdateSignInSessionMutation */.wWz)(), 1), updateSignInSession = ref[0];
    var initialize = react.useCallback((0,src_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, messageToken, messaging;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!clientTokenRef.current) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return firebase_message_token_firebaseMessageToken();
                case 4:
                    ref = _ctx.sent;
                    messageToken = ref.messageToken;
                    messaging = ref.messaging;
                    if (!(!messageToken || !messaging)) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 9:
                    clientTokenRef.current = messageToken;
                    // 서버에 토큰 저장 로직
                    updateSignInSession({
                        variables: {
                            deviceRegistrationToken: messageToken,
                            language: language
                        }
                    });
                    // 포그라운드일 경우 메시지 이벤트 핸들러(백그라운드인 경우에는 service worker에서 핸들링)
                    (0,messaging_dist_esm_index_esm/* onMessage */.ps)(messaging, function(payload) {
                        if (payload.notification && payload.notification.title) {
                            var ref;
                            var query = (router_default()).query;
                            // 알림온 방에서 현재 채팅중인 경우 필터(채팅 url path에 의존함에 주의)
                            var chatId = query["chatId"] || query["chat-id"];
                            if (isChattingPage() && chatId && ((ref = payload.data) === null || ref === void 0 ? void 0 : ref.linkUrl)) {
                                var isEqualChattingPage = payload.data.linkUrl.indexOf(chatId) > -1;
                                if (isEqualChattingPage) return; // 채팅페이지에서 현재 페이지와 같은 링크의 알림인 경우 알림 노출 안함
                            }
                            var notification = new Notification(payload.notification.title, {
                                body: payload.notification.body,
                                icon: "/icon-192x192.png"
                            });
                            notification.onclick = function(event) {
                                var ref;
                                event.preventDefault() // prevent the browser from focusing the Notification's tab
                                ;
                                if ((ref = payload.data) === null || ref === void 0 ? void 0 : ref.linkUrl) {
                                    notification.close();
                                    linkHandler({
                                        link: payload.data.linkUrl
                                    });
                                }
                            };
                        }
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        language,
        updateSignInSession
    ]);
    react.useEffect(function() {
        if (token) {
            initialize();
        }
    }, [
        token,
        initialize
    ]);
    // 창이 열려있는 포커싱되지 않은 백그라운드 상태인 경우에는 직접 핸들링
    react.useEffect(function() {
        var ref;
        var messageEventHandler = function(event) {
            if (event.data.type === "FCM") {
                if (event.data.action === "route-push" && event.data.url) {
                    linkHandler({
                        link: event.data.url
                    });
                }
            }
        };
        (ref = navigator.serviceWorker) === null || ref === void 0 ? void 0 : ref.addEventListener("message", messageEventHandler);
        return function() {
            var ref;
            (ref = navigator.serviceWorker) === null || ref === void 0 ? void 0 : ref.removeEventListener("message", messageEventHandler);
        };
    }, []);
};
function linkHandler(param) {
    var link = param.link;
    var ref = (0,_sliced_to_array/* default */.Z)(link.split("#")[0].split(location.origin), 2), path = ref[1];
    var isEqualPage = path === location.pathname;
    if (isEqualPage) {
        location.href = link;
        location.reload();
    } else {
        router_default().push(link);
    }
}

;// CONCATENATED MODULE: ./src/api/firebase/firebase-cloud-messaging-delete-token-hook.ts





function useDeleteFirebaseCloudMessagingToken() {
    return React.useCallback(_async_to_generator(regeneratorRuntime.mark(function _callee() {
        var messaging;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return isSupported();
                case 2:
                    _ctx.t0 = _ctx.sent;
                    if (!_ctx.t0) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.t0 = IS_PRODUCTION;
                case 5:
                    if (!_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    {
                        messaging = getMessaging();
                        deleteToken(messaging);
                    }
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
};

;// CONCATENATED MODULE: ./src/api/firebase/index.ts
/**
 * FCM 알림 클릭시 시나리오
 *
 * 1. 포그라운드 상황(firebase-cloud-messaging-hook)
 * 웹앱에 정의된(메인 쓰레드에서 동작하는 코드) onMessage 함수로 핸들링
 * router.push
 *
 * 2. 백그라운드 상황(firebase-cloud-messaging-sw)
 * worker.ts에 정의된 onBackgroundMessage FCM API를 사용하여 서비스워커에서 웹앱으로 메시지 전송 후 웹앱에서 핸들링
 * router.push
 */ 




;// CONCATENATED MODULE: ./src/components/third-party/ga-hook.ts

var useGA = function(param) {
    var userId = param.userId;
    react.useEffect(function() {
        if (typeof window.gtag === "function" && userId) {
            window.gtag("set", {
                user_id: userId
            });
        }
    }, [
        userId
    ]);
};
/* harmony default export */ var ga_hook = (useGA);

// EXTERNAL MODULE: ./node_modules/logrocket/dist/build.umd.js
var build_umd = __webpack_require__(19258);
var build_umd_default = /*#__PURE__*/__webpack_require__.n(build_umd);
;// CONCATENATED MODULE: ./src/utils/browser/exclude-paths-hook.ts

// 특정 path가 현재 url path에 해당하는 path일 경우 true 반환
function useIsExcludePaths(param) {
    var paths = param.paths;
    var asPath = (0,router.useRouter)().asPath;
    return paths.some(function(path) {
        return asPath.startsWith(path);
    });
};

;// CONCATENATED MODULE: ./src/components/third-party/logrocket-hook.ts



var excludePaths = [
    "/mbti-test",
    "/verification/email"
];
var useLogrocket = function(param) {
    var userId = param.userId, nickName = param.nickName;
    var isExcludePaths = useIsExcludePaths({
        paths: excludePaths
    });
    react.useEffect(function() {
        if ( true && !isExcludePaths) {
            build_umd_default().init("lsgb6x/therichweb");
            if (userId && nickName) {
                build_umd_default().identify(userId, {
                    name: nickName,
                    nickName: nickName
                });
            }
        }
    }, [
        nickName,
        userId,
        isExcludePaths
    ]);
};
/* harmony default export */ var logrocket_hook = (useLogrocket);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
;// CONCATENATED MODULE: ./src/components/third-party/channel-talk.ts

var ChannelService = /*#__PURE__*/ function() {
    "use strict";
    function ChannelService() {
        (0,_class_call_check/* default */.Z)(this, ChannelService);
        this.loadScript();
    }
    var _proto = ChannelService.prototype;
    _proto.loadScript = function loadScript() {
        var l = function l() {
            var ref;
            if (w.ChannelIOInitialized) {
                return;
            }
            w.ChannelIOInitialized = true;
            var s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
            s.charset = "UTF-8";
            var x = document.getElementsByTagName("script")[0];
            (ref = x.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(s, x);
        };
        var w = window;
        if (w.ChannelIO) {
            return (window.console.error || window.console.log || function() {
                return null;
            })("ChannelIO script included twice.");
        }
        var ch = function() {
            // eslint-disable-next-line prefer-rest-params
            ch.c(arguments);
        };
        ch.q = [];
        ch.c = function(args) {
            ch.q.push(args);
        };
        w.ChannelIO = ch;
        if (document.readyState === "complete") {
            l();
        } else if (window.attachEvent) {
            window.attachEvent("onload", l);
        } else {
            window.addEventListener("DOMContentLoaded", l, false);
            window.addEventListener("load", l, false);
        }
    };
    _proto.boot = function boot(settings) {
        var ref;
        (ref = window.ChannelIO) === null || ref === void 0 ? void 0 : ref.call(window, "boot", settings);
    };
    ChannelService.shutdown = function shutdown() {
        var ref;
        (ref = window.ChannelIO) === null || ref === void 0 ? void 0 : ref.call(window, "shutdown");
    };
    ChannelService.showChannelButton = function showChannelButton() {
        var ref;
        (ref = window.ChannelIO) === null || ref === void 0 ? void 0 : ref.call(window, "showChannelButton");
    };
    ChannelService.hideChannelButton = function hideChannelButton() {
        var ref;
        (ref = window.ChannelIO) === null || ref === void 0 ? void 0 : ref.call(window, "hideChannelButton");
    };
    return ChannelService;
}();
/* harmony default export */ var channel_talk = (ChannelService);

;// CONCATENATED MODULE: ./src/components/third-party/channel-talk-hook.ts





var hidePaths = [
    "/community",
    "/the-rich-game",
    "/mbti-test",
    "/ie-guide",
    "/events/",
    "/portfolio-generator",
    "/mailing-group",
    "/trading-fee-calculator",
    "/loan-interest-calculator",
    "/risk-tolerance-assessment",
    "/professional-investor-badge",
    "/professional-investor-application",
    "/badge-system",
    "/ebest", 
];
function useChannelTalk() {
    var asPath = (0,router.useRouter)().asPath;
    var channelServiceRef = react.useRef(null);
    var channelBoot = react.useCallback(function() {
        if (!channelServiceRef.current) {
            channelServiceRef.current = new channel_talk();
        }
        var userId = (0,auth/* getAuthTokenUserId */.st)();
        var option = userId ? {
            memberId: userId,
            profile: {
                name: (0,auth/* getAuthTokenNickname */.Yj)()
            }
        } : {};
        channelServiceRef.current.boot((0,src_object_spread/* default */.Z)({
            pluginKey: "84b8a5eb-6093-4f42-873b-5bcc5725843c"
        }, option));
    }, []);
    react.useEffect(function() {
        channelBoot();
    }, [
        channelBoot
    ]);
    react.useEffect(function() {
        if (hidePaths.find(function(path) {
            return asPath.startsWith(path);
        })) {
            channel_talk.hideChannelButton();
        } else {
            channel_talk.showChannelButton();
        }
    }, [
        asPath,
        channelBoot
    ]);
};

;// CONCATENATED MODULE: ./src/components/third-party/index.tsx








initialize();
function ThirdPartyOnlyProduction(param) {
    var children = param.children;
    var token = (0,auth/* useAuthToken */.pk)().token;
    var ref, ref1;
    var user = react.useMemo(function() {
        return {
            userId: token ? (ref = (0,auth/* getAuthTokenUserId */.st)()) !== null && ref !== void 0 ? ref : "" : "",
            nickName: token ? (ref1 = (0,auth/* getAuthTokenNickname */.Yj)()) !== null && ref1 !== void 0 ? ref1 : "" : ""
        };
    }, [
        token
    ]);
    ga_hook({
        userId: user.userId
    });
    logrocket_hook(user);
    useChannelTalk();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
}
function IsNeedThirdParty(param) {
    var children = param.children;
    useFirebaseCloudMessaging();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: env/* IS_PRODUCTION */.Mw ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdPartyOnlyProduction, {
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
}
/* harmony default export */ var third_party = (/*#__PURE__*/react.memo(IsNeedThirdParty));


/***/ }),

/***/ 70340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mw": function() { return /* binding */ IS_PRODUCTION; },
/* harmony export */   "Sy": function() { return /* binding */ IS_PRODUCTION_OPERATION; },
/* harmony export */   "v9": function() { return /* binding */ IS_DEVELOPMENT; }
/* harmony export */ });
/* unused harmony export IMAGE_SERVER */
var IS_PRODUCTION_OPERATION = "preview" === "production";
var IS_PRODUCTION = "production" === "production";
var IS_DEVELOPMENT = "production" === "development";
var IMAGE_SERVER = "https://images.therich.io";


/***/ }),

/***/ 82907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ KoreanEnum; },
/* harmony export */   "U": function() { return /* binding */ LocaleEnum; }
/* harmony export */ });
var LocaleEnum;
(function(LocaleEnum) {
    LocaleEnum["en"] = "en";
    LocaleEnum["ko"] = "ko";
})(LocaleEnum || (LocaleEnum = {}));
var KoreanEnum;
(function(KoreanEnum) {
    KoreanEnum["ko-kr"] = "ko-kr";
    KoreanEnum["ko"] = "ko";
    KoreanEnum["kr"] = "kr";
})(KoreanEnum || (KoreanEnum = {}));


/***/ }),

/***/ 54576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26524);
/* harmony import */ var _types_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82907);


var useLanguage = function(ns) {
    var ref = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)(ns), t = ref.t, i18n = ref.i18n;
    var language = i18n.language;
    var isKorean = language === _types_locale__WEBPACK_IMPORTED_MODULE_0__/* .LocaleEnum.ko */ .U.ko;
    return {
        t: t,
        language: language,
        isKorean: isKorean
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLanguage);


/***/ })

}]);